import { PATH as forgetPasswordRoutes } from '@axa-asia/emma-forget-password';
import { forgetUsernameRoutes } from '@axa-asia/emma-forget-username';
import { Path, Paths } from '@axa-asia/emma-registration';
import config from './config';

export const ROUTE_FORGOT = {
  path: 'forget',
  container: null,
  children: [
    {
      path: 'password',
      container: () => import('./containers/Forget/ForgetPasswordContainer_v2'),
      children: [
        {
          path: 'reset',
          container: () => import('./containers/Forget/ResetPassword_v2'),
        },
        {
          path: 'setup-acc-success',
          container: () =>
            import('./containers/Forget/ForgetPasswordSetUpSuccess_v2'),
        },
        {
          path: 'setup-account',
          container: () =>
            import('./containers/Forget/ForgetPasswordSetupAccount_v2'),
        },
        {
          path: 'setup-acc-fail',
          container: () =>
            import('./containers/Forget/ForgetPasswordSetUpFail_v2'),
        },
        {
          path: 'acc-reactivate-success',
          container: () =>
            import('./containers/Forget/ReactivateAccountSuccess_v2'),
        },
        {
          path: 'acc-reactivate-fail',
          container: () =>
            import('./containers/Forget/ReactivateAccountFail_v2'),
        },
        {
          path: 'reset-success',
          container: () =>
            import('./containers/Forget/ResetPasswordSuccess_v2'),
        },
        {
          path: 'reset-fail',
          container: () => import('./containers/Forget/ResetPasswordFail_v2'),
        },
      ],
    },
    {
      // default and exception routes
      path: null,
      container: () => import('./containers/Forget/ForgetContainer_v2'),
      children: [
        {
          path: 'acc-reactivate-success',
          container: () =>
            import('./containers/Forget/ReactivateAccountSuccess_v2'),
        },
        {
          path: 'acc-reactivate-fail',
          container: () =>
            import('./containers/Forget/ReactivateAccountFail_v2'),
        },
      ],
    },
  ],
};

export const ROUTE_FIND_MY_POLICY = {
  path: 'find-my-policy',
  container: () => import('./containers/FindMyPolicy/FindMyPolicyContainer'),
  index: () => import('./containers/FindMyPolicy/FindPolicyTypeSelection_v2'),
  children: [
    {
      path: 'individual-policy',
      index: () =>
        import(
          './containers/FindMyPolicy/FindPolicyIndividualPolicySelection_v2'
        ),
      children: [
        {
          path: 'hkid-selected',
          container: () =>
            import(
              './containers/FindMyPolicy/FindPolicyIndividualHKIdSelected_v2'
            ),
        },
        {
          path: 'chinaId-selected',
          container: () =>
            import('./containers/FindMyPolicy/FindPolicyChinaIdSelected_v2'),
        },
        {
          path: 'passport-selected',
          container: () =>
            import(
              './containers/FindMyPolicy/FindPolicyIndividualPassportSelected_v2'
            ),
        },
        {
          path: 'policyfound-fail',
          container: () =>
            import('./containers/FindMyPolicy/FindPolicyFail_v2'),
        },
        {
          path: 'policy-found',
          container: () =>
            import('./containers/FindMyPolicy/FindPolicyFound_v2'),
        },
        {
          path: 'policy-not-match',
          container: () =>
            import('./containers/FindMyPolicy/FindPolicyNotMatch_v2'),
        },
        {
          path: 'policy-verify',
          container: () =>
            import('./containers/FindMyPolicy/FindPolicyVerificationStatus_v2'),
        },
      ],
    },
    {
      path: 'employee-benefit',
      index: () =>
        import('./containers/FindMyPolicy/FindPolicyCompanyPolicySelection_v2'),
      children: [
        {
          path: 'axa-card-selected',
          container: () =>
            import('./containers/FindMyPolicy/FindPolicyAxaCardSelected_v2'),
        },
        {
          path: 'other-card-selected',
          container: () =>
            import('./containers/FindMyPolicy/FindPolicyOtherCardSelected_v2'),
        },
        {
          path: 'policyfound-fail',
          container: () =>
            import('./containers/FindMyPolicy/FindPolicyFail_v2'),
        },
        {
          path: 'policy-found',
          container: () =>
            import('./containers/FindMyPolicy/FindPolicyFound_v2'),
        },
        {
          path: 'policy-not-match',
          container: () =>
            import('./containers/FindMyPolicy/FindPolicyNotMatch_v2'),
        },
        {
          path: 'policy-verify',
          container: () =>
            import('./containers/FindMyPolicy/FindPolicyVerificationStatus_v2'),
        },
      ],
    },
    {
      isEnabled: config.isPncEnabled,
      path: 'property-and-casualty',
      index: () =>
        import('./containers/FindMyPolicy/FindPolicyPncPolicySelection_v2'),
      children: [
        {
          path: 'hkid-selected',
          container: () =>
            import('./containers/FindMyPolicy/FindPolicyPncHKIdSelected_v2'),
        },
        {
          path: 'passport-selected',
          container: () =>
            import(
              './containers/FindMyPolicy/FindPolicyPncPassportSelected_v2'
            ),
        },
        {
          path: 'policyfound-fail',
          container: () =>
            import('./containers/FindMyPolicy/FindPolicyFail_v2'),
        },
        {
          path: 'policy-found',
          container: () =>
            import('./containers/FindMyPolicy/FindPolicyFound_v2'),
        },
        {
          path: 'policy-not-match',
          container: () =>
            import('./containers/FindMyPolicy/FindPolicyNotMatch_v2'),
        },
        {
          path: 'policy-verify',
          container: () =>
            import('./containers/FindMyPolicy/FindPolicyVerificationStatus_v2'),
        },
      ],
    },
  ],
};

export const ROUTE_REGISTRATION = {
  path: Paths[Path.PoCwpSelection],
  container: () => import('./containers/GeneralContainer'),
  index: () =>
    import('@axa-asia/emma-registration/dist/pages/PoCwpSelection').then(
      (mod) => mod.PoCwpSelection,
    ),
  children: [
    {
      path: Path.PolicyTypeSelection,
      index: () =>
        import(
          '@axa-asia/emma-registration/dist/pages/PolicyTypeSelection'
        ).then((mod) => mod.PolicyTypeSelection),
    },
    {
      path: Path.PolicyInfoInput,
      index: () =>
        import('@axa-asia/emma-registration/dist/pages/PolicyInfoInput').then(
          (mod) => mod.PolicyInfoInput,
        ),
    },
    {
      path: Path.ReviewInformation,
      index: () =>
        import('@axa-asia/emma-registration/dist/pages/ReviewInformation').then(
          (mod) => mod.ReviewInformation,
        ),
    },
    {
      path: Path.SelectUsername,
      index: () =>
        import('@axa-asia/emma-registration/dist/pages/SelectUsername').then(
          (mod) => mod.SelectUsername,
        ),
    },
    {
      path: Path.InputUsername,
      index: () =>
        import('@axa-asia/emma-registration/dist/pages/InputUsername').then(
          (mod) => mod.InputUsername,
        ),
    },
    {
      path: Path.InputOtp,
      index: () =>
        import('@axa-asia/emma-registration/dist/pages/InputOtp').then(
          (mod) => mod.InputOtp,
        ),
    },
    {
      path: Path.SetPassword,
      index: () =>
        import('@axa-asia/emma-registration/dist/pages/SetPassword').then(
          (mod) => mod.SetPassword,
        ),
    },
    {
      path: Path.Success,
      index: () =>
        import('@axa-asia/emma-registration/dist/pages/Success').then(
          (mod) => mod.Success,
        ),
    },
  ],
};

// /forget-username
export const ROUTE_FORGET_USERNAME = {
  path: '',
  container: () => import('./containers/GeneralContainer'),
  children: [
    {
      path: forgetUsernameRoutes.policySelectionPage,
      index: () =>
        import('@axa-asia/emma-forget-username/dist/pages/select-policy'),
    },
    {
      path: forgetUsernameRoutes.inputInfoPage,
      index: () =>
        import('@axa-asia/emma-forget-username/dist/pages/input-info'),
    },
    {
      path: forgetUsernameRoutes.reviewInfoPage,
      index: () =>
        import('@axa-asia/emma-forget-username/dist/pages/review-info'),
    },
    {
      path: forgetUsernameRoutes.policyFoundPage,
      index: () =>
        import('@axa-asia/emma-forget-username/dist/pages/policy-found'),
    },
    {
      path: forgetUsernameRoutes.useOtherUsernameLifePage,
      index: () =>
        import(
          '@axa-asia/emma-forget-username/dist/pages/use-other-username/life'
        ),
    },
    {
      path: forgetUsernameRoutes.useOtherUsernameOtherPage,
      index: () =>
        import(
          '@axa-asia/emma-forget-username/dist/pages/use-other-username/non-life'
        ),
    },
    {
      path: forgetUsernameRoutes.otpPage,
      index: () => import('@axa-asia/emma-forget-username/dist/pages/otp'),
    },
    {
      path: forgetUsernameRoutes.resetPasswordPage,
      index: () =>
        import('@axa-asia/emma-forget-username/dist/pages/reset-password'),
    },
  ],
};

// /forget-password
export const ROUTE_FORGET_PASSWORD = {
  path: '',
  container: () => import('./containers/GeneralContainer'),
  children: [
    {
      path: forgetPasswordRoutes.LANDING.EMAIL,
      index: () => import('@axa-asia/emma-forget-password/dist/pages/landing').then(({ LandingPage }) => LandingPage),
    },
    {
      path: forgetPasswordRoutes.LANDING.MOBILE,
      index: () => import('@axa-asia/emma-forget-password/dist/pages/landing').then(({ LandingPage }) => LandingPage),
    },
    {
      path: forgetPasswordRoutes.OTP,
      index: () => import('@axa-asia/emma-forget-password/dist/pages/otp').then(({ OtpPage }) => OtpPage),
    },
    {
      path: forgetPasswordRoutes.RESET,
      index: () => import('@axa-asia/emma-forget-password/dist/pages/reset').then(({ ResetPage }) => ResetPage),
    },
    {
      path: forgetPasswordRoutes.SUCCESS,
      index: () => import('@axa-asia/emma-forget-password/dist/pages/success').then(({ SuccessPage }) => SuccessPage),
    },
  ],
};

export const ROUTE_IAM_ERROR = {
  path: 'error',
  container: () => import('./containers/GeneralContainer'),
  index: () => import('@axa-asia/emma-iam-error').then((mod) => mod.IamErrorPage),
};
